module.exports = __webpack_public_path__ + "img/bedside-var-01.be22e529.png";